/* eslint-disable react/no-unstable-nested-components */
import { LoadingOutlined } from '@ant-design/icons';
import { MessageDisplay, ImageLoader } from 'components/common';
import { useDocumentTitle, useScrollTop } from 'hooks';
import firebase from 'firebase/firebase';
import React from 'react';
import { ref, orderByChild, query } from 'firebase/database';
import { useList, useObject } from 'react-firebase-hooks/database';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { displayChatHour } from 'helpers/utils';

const Messages = () => {
  const { t } = useTranslation();
  useScrollTop();
  useDocumentTitle(t('titleMessages'));
  const history = useHistory();
  const store = useSelector((state) => ({
    user: state.auth
  }));
  const [chats, isLoadingChats, errorChats] = useList(
    query(
      ref(firebase.rdb, `users/${store.user.id}/chats`),
      orderByChild('lastMessageTimestamp')
    )
  );

  const onClickChat = (e) => {
    if (!e) return;
    history.push(
      `/message/${e.currentTarget.children[1].lastChild.textContent}`
    );
  };

  const DisplayLastMessage = (messageData) => {
    const { lastMessage, chatId } = messageData;
    const [lastMessageData, isLoadingLastMessageData, errorLastMessageData] =
      useObject(ref(firebase.rdb, `messages/${chatId}/${lastMessage}`));
    if (isLoadingLastMessageData) {
      return (
        <div className="loader">
          <h4>{t('loadingMessage')}</h4>
          <br />
          <LoadingOutlined style={{ fontSize: '3rem' }} />
        </div>
      );
    }
    if (errorLastMessageData) {
      return <MessageDisplay message={errorLastMessageData} />;
    }
    if (lastMessageData && !isLoadingLastMessageData) {
      return (
        <span>
          {lastMessageData.val().text}
          {' - '}
          {displayChatHour(lastMessageData.val().timestamp)}
        </span>
      );
    }
    return <div />;
  };

  const DisplayChat = (chatData) => {
    const { chat } = chatData;
    const [messages, isLoadingMessages, errorMessages] = useList(
      ref(firebase.rdb, `chats/${chat.key}`)
    );
    if (isLoadingMessages) {
      return (
        <div className="loader">
          <h4>{t('loadingMessage')}</h4>
          <br />
          <LoadingOutlined style={{ fontSize: '3rem' }} />
        </div>
      );
    }
    if (errorMessages) {
      return <MessageDisplay message={errorMessages} />;
    }
    if (messages && !isLoadingMessages) {
      const converted = Object.keys(messages[1].val()).map((key) => [
        key,
        messages[1].val()[key]
      ]);
      return converted.map(
        (member) =>
          member[0] !== store.user.id && (
            <div key={member[0]}>
              <div
                onClick={onClickChat}
                onKeyDown={onClickChat}
                className={`chat-conversation ${
                  member[1].unread > 0 && 'chat-unread'
                }`}
                role="presentation"
              >
                <div className="chat-img-wrapper">
                  <ImageLoader
                    alt="Image"
                    className="item-img chat-img"
                    src={member[1].avatar}
                  />
                </div>
                <div style={{ paddingLeft: '15px' }}>
                  <div>
                    {member[1].unread > 0
                      ? `${member[1].name} (${member[1].unread})`
                      : `${member[1].name}`}
                  </div>
                  <DisplayLastMessage
                    lastMessage={messages[0].val()}
                    chatId={chat.key}
                  />
                  <div style={{ display: 'none' }}>{chat.key}</div>
                </div>
              </div>
            </div>
          )
      );
    }
    return <div />;
  };

  return (
    <div style={{ margin: 'auto', display: 'block' }}>
      {isLoadingChats && (
        <div className="loader">
          <h4>{t('loadingMessage')}</h4>
          <br />
          <LoadingOutlined style={{ fontSize: '3rem' }} />
        </div>
      )}
      {errorChats && <MessageDisplay message={errorChats} />}
      {chats && !isLoadingChats && (
        <div>
          <h2>{t('messagesMainTitle')}</h2>
          <div>
            {chats.length !== 0 && (
              <div className="message-content">
                {chats
                  .slice(0)
                  .reverse()
                  .map((chat) => (
                    <DisplayChat key={chat.key} chat={chat} />
                  ))}
              </div>
            )}
            {chats.length === 0 && <p>{t('messagesEmpty')}</p>}
          </div>
        </div>
      )}
    </div>
  );
};

export default Messages;
